<template>
  <div class="col-md-12 categories-list-wrapper" v-if="isAllowedCategory">
    <ul class="categories-list">
      <li
        :key="category.slug"
        v-for="category in categoriesList"
        class="categories-list__item"
      >
        <router-link :to="categoryPath(category)">
          <div class="categories-list__img-wrapper">
            <img
              :src="categoryImage(category)"
              :alt="$h.getAlt(categoryTitle(category))"
              :title="categoryTitle(category)"
              class="categories-list__img"
            />
          </div>
          <div class="categories-list__title">
            {{ categoryTitle(category) }}
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
// import { mapActions, mapMutations, mapState } from 'vuex'
import { mapState } from 'vuex'

export default {
  name: 'CategoriesList',
  components: {},
  // data() {
  //   return {}
  // },
  computed: {
    ...mapState(['category', 'lang', 'categories']),
    isAllowedCategory() {
      return /product-category\/(iphone|used\/iphone)/m.test(this.$route.path)
    },
    categoriesList() {
      const category = this.categories.find(({ slug }) => slug === 'iphone')

      const { pathMatch } = this.$route.params
      const pathChain = pathMatch.split('/')
      const pathSlug = pathChain.pop()

      return [...category.children].filter(({ slug }) => slug !== pathSlug)
    },
  },
  methods: {
    categoryTitle(category) {
      const { locale } = this.$i18n
      const name = category[`name_${locale}`] || category.name || ''
      const usedTitle = this.isUsedCategory(category) ? ' Б/У' : ''

      return `${name}${usedTitle}`
    },
    isUsedCategory(category) {
      return (
        /used/m.test(this.category.currentPath) && !category.children.length
      )
    },
    categoryPath(category) {
      let path = ''

      if (this.lang) {
        path += `/${this.lang}`
      }

      path += '/product-category'

      if (this.isUsedCategory(category)) {
        path += '/used'
      }

      if (!category.children.length) {
        path += '/iphone'
      }

      path += `/${category.slug}`

      return path
    },
    categoryImage(category) {
      return `/img/categories/${category.slug}.png`
    },
  },
}
</script>

<style>
.categories-list-wrapper {
  margin-bottom: 30px;
  overflow: auto;
}
.categories-list {
  display: flex;
  margin: 0;
  padding: 0;
}
.categories-list__item {
  padding: 0 10px;
  list-style: none;
}
.categories-list__item:before {
  display: none;
}
.categories-list__img-wrapper {
  width: 100px;
  height: 100px;
  overflow: hidden;
}
.categories-list__img {
  object-fit: cover;
}
.categories-list__title {
  width: 100px;
  text-align: center;
  padding: 5px 0 15px;
}
</style>
